import status_tag from './status_tag.vue'
const StatusTag = {
    install: function (Vue) {
        Vue.component('StatusTag', status_tag)
    }
}
export default StatusTag
